var o;!function(o){o.LOGIN="login",o.LOGOUT="logout"}(o||(o={}));export{o as AuthEvent};
//# sourceMappingURL=useAuthBroadcast.types.js.map
